export const model = {
    fields: {
        name: {
            isRequired: true,
            errors: []
        },
        noteExternal: {
            isRequired: false,
            errors: []
        },
        idVyrobekSkupinaTree: {
            isRequired: true,
            errors: []
        }
    }
}